import api from '@pray/shared/utils/api';

export const toggleLikeComment = async ({ artistId, commentId, hasLiked } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!commentId) throw Error('Comment ID is required');

  const url = `/web/studio/artists/${artistId}/comments/${commentId}/reaction`;
  const response = hasLiked
    ? await api.executeDeleteRequest(url)
    : await api.executePostRequest(url);
  return response.data.data;
};
